import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { FiCheckCircle, FiDownload, FiArrowRight } from 'react-icons/fi';

export default function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const invoice = searchParams.get('invoice');
  const amount = searchParams.get('amount');

  return (
    <div style={{ paddingTop: 70, background: 'var(--bg)', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '80px 16px' }}>
      <div style={{ background: 'white', borderRadius: 'var(--radius-xl)', padding: '56px 48px', textAlign: 'center', maxWidth: 520, width: '100%', boxShadow: 'var(--shadow-xl)', border: '1px solid var(--border)' }}>
        <div style={{ width: 80, height: 80, background: '#d1fae5', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
          <FiCheckCircle size={40} color="var(--success)" />
        </div>
        <h1 style={{ fontSize: 28, marginBottom: 8 }}>Payment Successful! 🎉</h1>
        <p style={{ color: 'var(--mid)', marginBottom: 24 }}>Your payment has been confirmed and your enrollment is being processed.</p>

        {(invoice || amount) && (
          <div style={{ background: 'var(--bg)', borderRadius: 'var(--radius-lg)', padding: '20px', marginBottom: 28, border: '1px solid var(--border)' }}>
            {invoice && (
              <div style={{ marginBottom: 8 }}>
                <div style={{ fontSize: 12, color: 'var(--mid)', marginBottom: 2 }}>Invoice Number</div>
                <div style={{ fontWeight: 700, color: 'var(--primary)', fontSize: 18 }}>{invoice}</div>
              </div>
            )}
            {amount && (
              <div>
                <div style={{ fontSize: 12, color: 'var(--mid)', marginBottom: 2 }}>Amount Paid</div>
                <div style={{ fontWeight: 800, fontSize: 24, color: 'var(--success)', fontFamily: 'var(--font-display)' }}>
                  ₹{(parseInt(amount) / 100).toLocaleString()}
                </div>
              </div>
            )}
          </div>
        )}

        <p style={{ fontSize: 14, color: 'var(--mid)', marginBottom: 28, lineHeight: 1.6 }}>
          A confirmation email with your receipt has been sent to your registered email address. Our team will contact you within 24 hours to set up your access.
        </p>

        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/dashboard" className="btn btn-primary">Go to Dashboard <FiArrowRight size={15} /></Link>
          <Link to="/dashboard?tab=payments" className="btn btn-outline"><FiDownload size={15} /> Download Receipt</Link>
        </div>
      </div>
    </div>
  );
}
